export const APP_NAME_TITLE_CASE = 'Ferryhome';
export const BASE_URL = `https://app.${APP_NAME_TITLE_CASE.toLowerCase()}.com`
export const EMPTY_UUID = '00000000-0000-0000-0000-000000000000';
export const SENDGRID_SENDER_EMAIL = 'hello@ferryhome.com'
export const SENDGRID_SENDER_NAME = 'Ferryhome'
export const SUPPORTED_STATES = [
  'California',
  'New York',
]